import React, { useState } from 'react';

import getOwnerships from '../../hooks/getOwnerships';

import CollectionsComponent from '../../components/products/Collections';
import { ProductFiltersContributor } from '../../components/products/ProductFiltersContributor';
import { LinkIcon } from '../../modules/Icons';

import { CollectionPageContributorsProps } from '../../types/pages/c/username';

const CollectionPageContributors: React.FC<CollectionPageContributorsProps> = (props) => {
  const { contributorDetails } = props;

  const { ownerships } = getOwnerships();
  const collectionOwnership = ownerships;
  const [categoryFilter, setCategoryFilter] = useState('');

  const filteredCollections = contributorDetails.data?.filter((c) =>
    categoryFilter === null
      ? c
      : c.library.name.toLowerCase().includes(categoryFilter.toLowerCase())
  );

  const coverImage =
    contributorDetails.contributor.cover === 'https://uploads.actionvfx.com/attachment//medium_'
      ? '/img/licenses.jpg'
      : contributorDetails.contributor.cover.replace('medium_', '');

  const collectionLength = {
    all: filteredCollections?.length,
    twoD: filteredCollections?.filter((c) => c.library.name === '2D').length,
    threeD: filteredCollections?.filter((c) => c.library.name === '3D').length,
    practiceFootage: filteredCollections?.filter(
      (c) => c.library.name === 'Practice Footage Library'
    ).length
  };

  return (
    <div className="bg-[#252A2D]">
      <section
        style={{
          backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6) ), url(${coverImage})`
        }}
        className="h-[391px] w-full flex flex-col items-center justify-center relative bg-cover bg-center">
        <div className="mx-12 text-center">
          <img
            className="block mx-auto  w-[110px] h-[110px] rounded-full mb-6"
            src={contributorDetails.contributor.avatar}
            alt="ContributorProfilePic"
            loading="lazy"
          />
          <div className="text-white leading-44 text-[32px] md:text-[40px] font-bold mx-auto mb-2.5">
            {contributorDetails.contributor.name}
          </div>
          <p className="text-[#AEB6BA] !text-[12px] md:!text-[18px] leading-30 !font-400 mb-2.5">
            {contributorDetails.contributor.description}
          </p>
          <a
            href="https://sell.actionvfx.com/"
            className="flex gap-2 items-center justify-center text-a-blue text-[10px] sm:text-[14px] leading-22 font-400">
            Sell on ActionVFX <LinkIcon className="" />
          </a>
        </div>
      </section>

      <section className="px-4 py-8 md:px-20 lg:px-32 min-h-[700px]">
        <ProductFiltersContributor
          categoryFilter={categoryFilter}
          setCategoryFilter={setCategoryFilter}
          collectionLength={collectionLength}
        />

        <CollectionsComponent
          collections={filteredCollections}
          totalPages={contributorDetails?.total_pages}
          currentPage={contributorDetails?.page}
          collectionOwnership={collectionOwnership}
        />
      </section>
    </div>
  );
};

export default CollectionPageContributors;
